/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-is-mounted */
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';

import SpinnerOverlay from '../../../../components/SpinnerOverlay/SpinnerOverlay';
import useAxios from '../../../../hooks/useAxios';
import { handleError } from '../../../../utils';
import './DueDateForm.scss';

const DueDateForm = () => {
  const navigate = useNavigate();
  const toast = useRef(null);
  const toastBottom = useRef(null);

  const { duedateid } = useParams();
  const { state } = useLocation();
  const [allMaterialTypes, setAllMaterialTypes] = useState([]);
  const [selectedWorkflow, setSelectedWorkflow] = useState(null);
  const [selectedMaterialType, setSelectedMaterialType] = useState(null);
  const [selectedUnitType, setSelectedUnitType] = useState(null);
  const [largeAssetValue, setLargeAssetValue] = useState(null);
  const [largeAssetUnit, setLargeAssetUnit] = useState(null);
  const [businessDays, setBusinessDays] = useState(null);

  const { get, post, apiLoading } = useAxios();

  const defaultOptions = {
    workflow_type: '',
    file_type: '',
    large_assets: 1,
    business_unit: 1
  };

  const {
    formState: { errors },
    handleSubmit
  } = useForm({ defaultOptions });

  const getFormErrorMessage = (name: any) => {
    return errors[name] && <small className="p-error">{errors[name].message}</small>;
  };

  const getMaterialTypes = async () => {
    await get('workflow-manager/get_all_material_file_type_details').then((response: any) => {
      const { status } = response;

      if ([200, 201].includes(status)) {
        setAllMaterialTypes(response.data.messages[0].map((item: any) => {
          item.file_type_label = item.file_type.toUpperCase();
          return item;
        }));
      }
    });
  };

  setTimeout(() => {
    if (document.getElementsByClassName('p-inputnumber-buttons-stacked')) {
      document.getElementsByClassName('p-inputnumber-buttons-stacked')[0].style.width = '100%';
      document.getElementsByClassName('p-inputnumber-buttons-stacked')[1].style.width = '100%';
    }
    if (duedateid && state) {
      setSelectedMaterialType(allMaterialTypes.find(item => item.file_type_label === state.file_type));
    }
  }, 200);

  const workflowTypes = [{ label: 'Standard', value: 'standard' }, { label: 'Collaboration', value: 'concept' }];

  const onSubmit = async () => {
    let postData;
    if (!duedateid) {
      postData = {
        workflow_type: selectedWorkflow,
        file_type: selectedMaterialType.file_type,
        unit_value: largeAssetValue,
        unit_type: selectedUnitType,
        business_days: businessDays
      };

      await post('workflow-manager/create_new_due_date_rule', postData).then((response: any) => {
        const { status } = response;

        if ([200, 201].includes(status)) {
          if (response.data.messages[0]) {
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Due Date Added successfully!', life: 3000 });
            setTimeout(() => {
              navigate('/settings/due-date-management');
            }, 300);
          } else if (response.data.errors[0]) {
            toastBottom.current.show({ severity: 'error', summary: 'Error', detail: response.data.errors[0] });
          }
        }
      })
        .catch((error: any) => {
          if ([401, 404, 500].includes(error?.request?.status)) {
            handleError(error, toastBottom);
          }
        });
    } else {
      postData = {
        rule_id: duedateid,
        unit_value: largeAssetValue,
        business_days: businessDays
      };

      await post('workflow-manager/update_existing_due_date_rule', postData).then((response: any) => {
        const { status } = response;

        if ([200, 201].includes(status)) {
          if (response.data.messages[0]) {
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Due Date Updated successfully!', life: 3000 });
            setTimeout(() => {
              navigate('/settings/due-date-management');
            }, 300);
          } else if (response.data.errors[0]) {
            toastBottom.current.show({ severity: 'error', summary: 'Error', detail: response.data.errors[0] });
          }
        }
      })
        .catch((error: any) => {
          if ([401, 404, 500].includes(error?.request?.status)) {
            handleError(error, toastBottom);
          }
        });
    }
  };

  useEffect(() => {
    getMaterialTypes();
    if (duedateid && state) {
      setSelectedWorkflow(state.workflow_type.charAt(0).toLowerCase() + state.workflow_type.slice(1));
      setLargeAssetValue(state.unit_value);
      setLargeAssetUnit(state.unit_label);
      setBusinessDays(state.business_days);
    }
  }, []);

  function isFormValid(): boolean {
    return (duedateid && state) ? !(state.unit_value !== largeAssetValue || state.business_days !== businessDays)
      : !(selectedWorkflow !== null && selectedMaterialType !== null && largeAssetValue !== null && businessDays !== null);
  }

  const setFormValues = (data: any) => {
    setSelectedMaterialType(data.value);
    setLargeAssetUnit(data.value.unit_label);
    setSelectedUnitType(data.value.unit_type);
  };

  return (
    <div role="add-dueDateform" className="dueDateform-container">
      <Toast ref={toast} />
      <Toast ref={toastBottom} position="bottom-right" />

      {apiLoading && (
        <div className="card">
          <SpinnerOverlay />
        </div>
      )}
      <div className="card">
        <div className="flex flex-wrap align-items-center justify-content-between gap-2 mb-2 userform-header">
          <span className="table-header-title">{(duedateid && state && state.isView) ? 'View Due Date' : (duedateid && state && !state.isView) ? 'Edit Due Date' : 'Create Due Date'}</span>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="userform-inner">
          <div className="workflow-info-container">
            <div className="details-style">
              Details
            </div>
            <div className="flex">
              <div className="field col-6 pl-0">
                <label className="fieldlabel" htmlFor="workflow_type">Workflow Type</label>
                <div className="w-full">
                  <div className="card cus-field-container">
                    <Dropdown
                      value={selectedWorkflow}
                      onChange={(e) => setSelectedWorkflow(e.value)}
                      options={workflowTypes}
                      optionLabel="label"
                      placeholder="Select the workflow type"
                      className="w-full subfield-dropdown"
                      disabled={duedateid && state}
                      appendTo="self"
                    />
                  </div>
                  <small className="field-help-text" id="workflow_type-help">
                    {getFormErrorMessage('workflow_type')}
                  </small>
                </div>
              </div>
              <div className="field col-6 pl-0">
                <label className="fieldlabel" htmlFor="file_type">File Type</label>
                <div className="w-full">
                  <div className="card cus-field-container">
                    <Dropdown
                      value={selectedMaterialType}
                      onChange={(e) => { setFormValues(e); }}
                      options={allMaterialTypes}
                      optionLabel="file_type_label"
                      placeholder="Select the File type"
                      className="w-full subfield-dropdown"
                      disabled={duedateid && state}
                      appendTo="self"
                    />
                  </div>
                  <small className="field-help-text" id="file_type-help">
                    {getFormErrorMessage('file_type')}
                  </small>
                </div>
              </div>
            </div>
            <div className="flex">
              <div className="field col-6 pl-0">
                <label className="fieldlabel" htmlFor="large_asset">Asset Size Threshold</label>
                <div className="w-full">
                  <div className="flex">
                    <InputNumber
                      className="cus-input-btn"
                      showButtons
                      min={1}
                      value={largeAssetValue}
                      placeholder="Enter Asset Size Threshold"
                      onValueChange={(e) => setLargeAssetValue(e.value)}
                      disabled={state && state.isView}
                    />
                    <span className="fieldlabel pl-2 large-asset-unit">{largeAssetUnit}</span>
                  </div>
                  <small className="field-help-text" id="large-assets-help">
                    {getFormErrorMessage('large_assets')}
                  </small>
                </div>
              </div>
              <div className="field col-6 pl-0">
                <label className="fieldlabel" htmlFor="business_Days">Due Days (Business Days)</label>
                <div className="w-full">
                  <div className="card cus-field-container">
                    <InputNumber
                      className="cus-input-btn"
                      showButtons
                      min={1}
                      value={businessDays}
                      placeholder="Enter Due Date Days"
                      onValueChange={(e) => setBusinessDays(e.value)}
                      disabled={state && state.isView}
                      minFractionDigits={0}
                      maxFractionDigits={0}
                    />
                  </div>
                  <small className="field-help-text" id="business-unit-help">
                    {getFormErrorMessage('business_unit')}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full mt-4 flex btn-container justify-content-end">
            <Button className="outline-btn mr-2" type="button" outlined label="Back" onClick={() => { navigate('/settings/due-date-management'); }} />
            {state && state.isView ? null
              : (
                <Button
                  type="submit"
                  rounded
                  raised
                  label={duedateid && state ? 'Save Due Date' : 'Create Due Date'}
                  disabled={isFormValid()}
                  iconPos="right"
                />

              )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default DueDateForm;
